import { CurrencyInfo } from 'types/common'

export const currencies: Record<string, CurrencyInfo> = {
  GBP: {
    currency: 'British Pound',
    symbol: '£',
    code: 'GBP',
    fraction: 2,
    country: 'GB',
  },
  EUR: {
    currency: 'Euro',
    symbol: '€',
    code: 'EUR',
    fraction: 2,
    country: 'EU',
  },
  USD: {
    currency: 'United States Dollar',
    symbol: '$',
    code: 'USD',
    fraction: 2,
    country: 'US',
  },
  AUD: {
    currency: 'Australian Dollar',
    symbol: 'A$',
    code: 'AUD',
    fraction: 2,
    country: 'AU',
  },
  CAD: {
    currency: 'Canadian Dollar',
    symbol: 'C$',
    code: 'CAD',
    fraction: 2,
    country: 'CA',
  },
  CZK: {
    currency: 'Czech Koruna',
    symbol: 'Kč',
    code: 'CZK',
    fraction: 2,
    country: 'CZ',
  },
  DKK: {
    currency: 'Danish Krone',
    symbol: 'Dkr',
    code: 'DKK',
    fraction: 2,
    country: 'DK',
  },
  JPY: {
    currency: 'Japanese Yen',
    symbol: '¥',
    code: 'JPY',
    fraction: 0,
    country: 'JP',
  },
  MXN: {
    currency: 'Mexican Peso',
    symbol: 'M$',
    code: 'MXN',
    fraction: 2,
    country: 'MX',
  },
  PLN: {
    currency: 'Polish Zloty',
    symbol: 'zł',
    code: 'PLN',
    fraction: 2,
    country: 'PL',
  },
  RON: {
    currency: 'Romanian Leu',
    symbol: 'lei',
    code: 'RON',
    fraction: 2,
    country: 'RO',
  },
  SEK: {
    currency: 'Swedish Krona',
    symbol: 'kr',
    code: 'SEK',
    fraction: 2,
    country: 'SE',
  },
  THB: {
    currency: 'Thai Baht',
    symbol: '฿',
    code: 'THB',
    fraction: 2,
    country: 'TH',
  },
  AED: {
    currency: 'United Arab Emirates Dirham',
    symbol: 'AED',
    code: 'AED',
    fraction: 2,
    country: 'AE',
  },
  CHF: {
    currency: 'Swiss Franc',
    symbol: 'Fr',
    code: 'CHF',
    fraction: 2,
    country: 'CH',
  },
  HKD: {
    currency: 'Hong Kong Dollar',
    symbol: 'H$',
    code: 'HKD',
    fraction: 2,
    country: 'HK',
  },
  HUF: {
    currency: 'Hungarian Forint',
    symbol: 'Ft',
    code: 'HUF',
    fraction: 2,
    country: 'HU',
  },
  ILS: {
    currency: 'Israeli New Sheqel',
    symbol: '₪',
    code: 'ILS',
    fraction: 2,
    country: 'IL',
  },
  NOK: {
    currency: 'Norwegian Krone',
    symbol: 'kr',
    code: 'NOK',
    fraction: 2,
    country: 'NO',
  },
  NZD: {
    currency: 'New Zealand Dollar',
    symbol: 'NZ$',
    code: 'NZD',
    fraction: 2,
    country: 'NZ',
  },
  SGD: {
    currency: 'Singapore Dollar',
    symbol: 'S$',
    code: 'SGD',
    fraction: 2,
    country: 'SG',
  },
  TRY: {
    currency: 'Turkish Lira',
    symbol: '₺',
    code: 'TRY',
    fraction: 2,
    country: 'TR',
  },
  ZAR: {
    currency: 'South African Rand',
    symbol: 'R',
    code: 'ZAR',
    fraction: 2,
    country: 'ZA',
  },
  SAR: {
    currency: 'Saudi Arabian Riyal',
    symbol: '﷼',
    code: 'SAR',
    fraction: 2,
    country: 'SA',
  },
  BGN: {
    currency: 'Bulgarian Lev',
    symbol: 'лв',
    code: 'BGN',
    fraction: 2,
    country: 'BG',
  },
  QAR: {
    currency: 'Qatari Riyal',
    symbol: '﷼',
    code: 'QAR',
    fraction: 2,
    country: 'QA',
  },
  ALL: {
    currency: 'Albanian Lek',
    symbol: 'LEK',
    code: 'ALL',
    fraction: 2,
    country: 'AL',
  },
  AFN: {
    currency: 'Afghan Afghani',
    symbol: '؋',
    code: 'AFN',
    fraction: 2,
    country: 'AF',
  },
  ARS: {
    currency: 'Argentine Peso',
    symbol: '$',
    code: 'ARS',
    fraction: 2,
    country: 'AR',
  },
  AWG: {
    currency: 'Aruban or Dutch Guilder',
    symbol: 'ƒ',
    code: 'AWG',
    fraction: 2,
    country: 'AW',
  },
  AZN: {
    currency: 'Azerbaijani New Manat',
    symbol: 'ман',
    code: 'AZN',
    fraction: 2,
    country: 'AZ',
  },
  BSD: {
    currency: 'Bahamian Dollar',
    symbol: '$',
    code: 'BSD',
    fraction: 2,
    country: 'BS',
  },
  BBD: {
    currency: 'Barbadian or Bajan Dollar',
    symbol: '$',
    code: 'BBD',
    fraction: 2,
    country: 'BB',
  },
  BZD: {
    currency: 'Belizean Dollar',
    symbol: 'BZ$',
    code: 'BZD',
    fraction: 2,
    country: 'BZ',
  },
  BMD: {
    currency: 'Bermudian Dollar',
    symbol: '$',
    code: 'BMD',
    fraction: 2,
    country: 'BM',
  },
  BOB: {
    currency: 'Bolivian Boliviano',
    symbol: '$b',
    code: 'BOB',
    fraction: 2,
    country: 'BO',
  },
  BAM: {
    currency: 'Bosnia Convertible Marka',
    symbol: 'KM',
    code: 'BAM',
    fraction: 2,
    country: 'BA',
  },
  BWP: {
    currency: 'Botswana Pula',
    symbol: 'P',
    code: 'BWP',
    fraction: 2,
    country: 'BW',
  },
  BRL: {
    currency: 'Brazilian Real',
    symbol: 'R$',
    code: 'BRL',
    fraction: 2,
    country: 'BR',
  },
  BND: {
    currency: 'Bruneian Dollar',
    symbol: '$',
    code: 'BND',
    fraction: 2,
    country: 'BN',
  },
  KHR: {
    currency: 'Cambodian Riel',
    symbol: '៛',
    code: 'KHR',
    fraction: 2,
    country: 'KH',
  },
  KYD: {
    currency: 'Caymanian Dollar',
    symbol: '$',
    code: 'KYD',
    fraction: 2,
    country: 'KY',
  },
  CLP: {
    currency: 'Chilean Peso',
    symbol: '$',
    code: 'CLP',
    fraction: 0,
    country: 'CL',
  },
  CNY: {
    currency: 'Chinese Yuan Renminbi',
    symbol: '¥',
    code: 'CNY',
    fraction: 2,
    country: 'CN',
  },
  COP: {
    currency: 'Colombian Peso',
    symbol: '$',
    code: 'COP',
    fraction: 2,
    country: 'CO',
  },
  CRC: {
    currency: 'Costa Rican Colon',
    symbol: '₡',
    code: 'CRC',
    fraction: 2,
    country: 'CR',
  },
  HRK: {
    currency: 'Croatian Kuna',
    symbol: 'kn',
    code: 'HRK',
    fraction: 2,
    country: 'HR',
  },
  CUC: {
    currency: 'Cuban Convertible Peso',
    symbol: '₱',
    code: 'CUC',
    fraction: 2,
    country: 'CU',
  },
  DOP: {
    currency: 'Dominican Peso',
    symbol: 'RD$',
    code: 'DOP',
    fraction: 2,
    country: 'DO',
  },
  XCD: {
    currency: 'East Caribbean Dollar',
    symbol: '$',
    code: 'XCD',
    fraction: 2,
    country: 'KN',
  },
  EGP: {
    currency: 'Egyptian Pound',
    symbol: 'E£',
    code: 'EGP',
    fraction: 2,
    country: 'EG',
  },
  SVC: {
    currency: 'Salvadoran Colon',
    symbol: '$',
    code: 'SVC',
    fraction: 2,
    country: 'SV',
  },
  EEK: {
    currency: 'Estonian Kroon',
    symbol: 'kr',
    code: 'EEK',
    fraction: 2,
    country: 'EE',
  },
  FKP: {
    currency: 'Falkland Island Pound',
    symbol: '£',
    code: 'FKP',
    fraction: 2,
    country: 'FK',
  },
  FJD: {
    currency: 'Fijian Dollar',
    symbol: '$',
    code: 'FJD',
    fraction: 2,
    country: 'FJ',
  },
  GIP: {
    currency: 'Gibraltar Pound',
    symbol: '£',
    code: 'GIP',
    fraction: 2,
    country: 'GI',
  },
  GTQ: {
    currency: 'Guatemalan Quetzal',
    symbol: 'Q',
    code: 'GTQ',
    fraction: 2,
    country: 'GT',
  },
  GGP: {
    currency: 'Guernsey Pound',
    symbol: '£',
    code: 'GGP',
    fraction: 2,
    country: 'GG',
  },
  HNL: {
    currency: 'Honduran Lempira',
    symbol: 'L',
    code: 'HNL',
    fraction: 2,
    country: 'HN',
  },
  ISK: {
    currency: 'Icelandic Krona',
    symbol: 'kr',
    code: 'ISK',
    fraction: 0,
    country: 'IS',
  },
  INR: {
    currency: 'Indian Rupee',
    symbol: '₹',
    code: 'INR',
    fraction: 2,
    country: 'IN',
  },
  IDR: {
    currency: 'Indonesian Rupiah',
    symbol: 'Rp',
    code: 'IDR',
    fraction: 2,
    country: 'ID',
  },
  IMP: {
    currency: 'Isle of Man Pound',
    symbol: '£',
    code: 'IMP',
    fraction: 2,
    country: 'IM',
  },
  JMD: {
    currency: 'Jamaican Dollar',
    symbol: 'J$',
    code: 'JMD',
    fraction: 2,
    country: 'JM',
  },
  JEP: {
    currency: 'Jersey Pound',
    symbol: '£',
    code: 'JEP',
    fraction: 2,
    country: 'JE',
  },
  KZT: {
    currency: 'Kazakhstani Tenge',
    symbol: 'лв',
    code: 'KZT',
    fraction: 2,
    country: 'KZ',
  },
  KRW: {
    currency: 'South Korean Won',
    symbol: '₩',
    code: 'KRW',
    fraction: 0,
    country: 'KR',
  },
  MAD: {
    currency: 'Moroccan Dirham',
    symbol: '.د.م',
    code: 'MAD',
    fraction: 2,
    country: 'MA',
  },
  RUB: {
    currency: 'Russian Ruble',
    symbol: '₽',
    code: 'RUB',
    fraction: 2,
    country: 'RU',
  },
  MYR: {
    currency: 'Malaysian Ringgit',
    symbol: 'RM',
    code: 'MYR',
    fraction: 2,
    country: 'MY',
  },
  PHP: {
    currency: 'Philippine Peso',
    symbol: '₱',
    code: 'PHP',
    fraction: 2,
    country: 'PH',
  },
  AMD: {
    currency: 'Armenian Dram',
    symbol: 'AMD',
    code: 'AMD',
    fraction: 2,
    country: 'AM',
  },
  ANG: {
    currency: 'Dutch Antilles Guilder',
    symbol: 'ƒ',
    code: 'ANG',
    fraction: 2,
    country: 'CW',
  },
  AOA: {
    currency: 'Angolan Kwanza',
    symbol: 'AOA',
    code: 'AOA',
    fraction: 2,
    country: 'AO',
  },
  BDT: {
    currency: 'Bangladeshi Taka',
    symbol: 'Tk',
    code: 'BDT',
    fraction: 2,
    country: 'BD',
  },
  BHD: {
    currency: 'Bahraini Dinar',
    symbol: 'BD',
    code: 'BHD',
    fraction: 3,
    country: 'BH',
  },
  BYN: {
    currency: 'Belarusian Ruble',
    symbol: 'Br',
    code: 'BYN',
    fraction: 2,
    country: 'BY',
  },
  CVE: {
    currency: 'Cape Verdean Escudo',
    symbol: 'CVE',
    code: 'CVE',
    fraction: 2,
    country: 'CV',
  },
  DZD: {
    currency: 'Algerian Dinar',
    symbol: 'DZD',
    code: 'DZD',
    fraction: 2,
    country: 'DZ',
  },
  ETB: {
    currency: 'Ethiopian Birr',
    symbol: 'Br',
    code: 'ETB',
    fraction: 2,
    country: 'ET',
  },
  GEL: {
    currency: 'Georgian Lari',
    symbol: 'GEL',
    code: 'GEL',
    fraction: 2,
    country: 'GE',
  },
  GHS: {
    currency: 'Ghanaian Cedi',
    symbol: 'GH¢',
    code: 'GHS',
    fraction: 2,
    country: 'GH',
  },
  GMD: {
    currency: 'Gambian Dalasi',
    symbol: 'D',
    code: 'GMD',
    fraction: 2,
    country: 'GM',
  },
  GNF: {
    currency: 'Guinean Franc',
    symbol: 'FG',
    code: 'GNF',
    fraction: 0,
    country: 'GN',
  },
  HTG: {
    currency: 'Haitian Gourde',
    symbol: 'G',
    code: 'HTG',
    fraction: 2,
    country: 'HT',
  },
  IQD: {
    currency: 'Iraqi Dinar',
    symbol: 'د.ع.',
    code: 'IQD',
    fraction: 2,
    country: 'IQ',
  },
  JOD: {
    currency: 'Jordanian Dinar',
    symbol: 'JOD',
    code: 'JOD',
    fraction: 3,
    country: 'JO',
  },
  KES: {
    currency: 'Kenyan Shilling',
    symbol: 'KSh.',
    code: 'KES',
    fraction: 2,
    country: 'KE',
  },
  KGS: {
    currency: 'Kyrgyzstani Som',
    symbol: 'лв',
    code: 'KGS',
    fraction: 2,
    country: 'KG',
  },
  KWD: {
    currency: 'Kuwaiti Dinar',
    symbol: 'دينار',
    code: 'KWD',
    fraction: 3,
    country: 'KW',
  },
  LAK: {
    currency: 'Laos Kip',
    symbol: '₭',
    code: 'LAK',
    fraction: 2,
    country: 'LA',
  },
  LBP: {
    currency: 'Lebanese Pound',
    symbol: '£',
    code: 'LBP',
    fraction: 2,
    country: 'LB',
  },
  LKR: {
    currency: 'Sri Lankan Rupee',
    symbol: '₨',
    code: 'LKR',
    fraction: 2,
    country: 'LK',
  },
  LSL: {
    currency: 'Lesotho Loti',
    symbol: 'L',
    code: 'LSL',
    fraction: 2,
    country: 'LS',
  },
  MDL: {
    currency: 'Moldovan Leu',
    symbol: 'lei',
    code: 'MDL',
    fraction: 2,
    country: 'MD',
  },
  MGA: {
    currency: 'Malagasy Ariary',
    symbol: 'Ar.',
    code: 'MGA',
    fraction: 0,
    country: 'MG',
  },
  MKD: {
    currency: 'Macedonian Denar',
    symbol: 'ден',
    code: 'MKD',
    fraction: 2,
    country: 'MK',
  },
  MMK: {
    currency: 'Myanmar Kyat',
    symbol: 'K',
    code: 'MMK',
    fraction: 2,
    country: 'MM',
  },
  MOP: {
    currency: 'Macanese Pataca',
    symbol: 'MOP$',
    code: 'MOP',
    fraction: 2,
    country: 'MO',
  },
  MUR: {
    currency: 'Mauritian Rupee',
    symbol: '₨',
    code: 'MUR',
    fraction: 2,
    country: 'MU',
  },
  MVR: {
    currency: 'Maldivian Rufiyaa',
    symbol: 'Rf',
    code: 'MVR',
    fraction: 2,
    country: 'MV',
  },
  MWK: {
    currency: 'Malawian Kwacha',
    symbol: 'MK',
    code: 'MWK',
    fraction: 2,
    country: 'MW',
  },
  MZN: {
    currency: 'Mozambican Metical',
    symbol: 'MT',
    code: 'MZN',
    fraction: 2,
    country: 'MZ',
  },
  NAD: {
    currency: 'Namibian Dollar',
    symbol: '$',
    code: 'NAD',
    fraction: 2,
    country: 'NA',
  },
  NGN: {
    currency: 'Nigerian Naira',
    symbol: '₦',
    code: 'NGN',
    fraction: 2,
    country: 'NG',
  },
  NIO: {
    currency: 'Nicaraguan Cordoba',
    symbol: 'C$',
    code: 'NIO',
    fraction: 2,
    country: 'NI',
  },
  NPR: {
    currency: 'Nepalese Rupee',
    symbol: '₨',
    code: 'NPR',
    fraction: 2,
    country: 'NP',
  },
  OMR: {
    currency: 'Omani Rial',
    symbol: '﷼',
    code: 'OMR',
    fraction: 3,
    country: 'OM',
  },
  PAB: {
    currency: 'Panama Balboa',
    symbol: 'B/.',
    code: 'PAB',
    fraction: 2,
    country: 'PA',
  },
  PEN: {
    currency: 'Peruvian Sol',
    symbol: 'S/.',
    code: 'PEN',
    fraction: 2,
    country: 'PE',
  },
  PGK: {
    currency: 'Papua New Guinean Kina',
    symbol: 'K',
    code: 'PGK',
    fraction: 2,
    country: 'PG',
  },
  PKR: {
    currency: 'Pakistani Rupee',
    symbol: '₨',
    code: 'PKR',
    fraction: 2,
    country: 'PK',
  },
  PYG: {
    currency: 'Paraguayan Guarani',
    symbol: 'Gs',
    code: 'PYG',
    fraction: 0,
    country: 'PY',
  },
  RSD: {
    currency: 'Serbian Dinar',
    symbol: 'Дин.',
    code: 'RSD',
    fraction: 2,
    country: 'RS',
  },
  RWF: {
    currency: 'Rwandan Franc',
    symbol: 'FRw',
    code: 'RWF',
    fraction: 0,
    country: 'RW',
  },
  SBD: {
    currency: 'Solomon Islands Dollar',
    symbol: '$',
    code: 'SBD',
    fraction: 2,
    country: 'SB',
  },
  SCR: {
    currency: 'Seychelles Rupee',
    symbol: '₨',
    code: 'SCR',
    fraction: 2,
    country: 'SC',
  },
  SRD: {
    currency: 'Surinamese Dollar',
    symbol: '$',
    code: 'SRD',
    fraction: 2,
    country: 'SR',
  },
  TMT: {
    currency: 'Turkmenistani New Manat',
    symbol: 'T',
    code: 'TMT',
    fraction: 2,
    country: 'TM',
  },
  TND: {
    currency: 'Tunisian Dinar',
    symbol: 'دينار',
    code: 'TND',
    fraction: 3,
    country: 'TN',
  },
  TOP: {
    currency: "Tongan Pa'anga",
    symbol: 'T$',
    code: 'TOP',
    fraction: 2,
    country: 'TO',
  },
  TTD: {
    currency: 'Trinidadian Dollar',
    symbol: 'TT$',
    code: 'TTD',
    fraction: 2,
    country: 'TT',
  },
  TWD: {
    currency: 'Taiwanese New Dollar',
    symbol: 'NT$',
    code: 'TWD',
    fraction: 2,
    country: 'TW',
  },
  TZS: {
    currency: 'Tanzanian Shilling',
    symbol: 'TZS',
    code: 'TZS',
    fraction: 2,
    country: 'TZ',
  },
  UAH: {
    currency: 'Ukrainian Hryvnia',
    symbol: '₴',
    code: 'UAH',
    fraction: 2,
    country: 'UA',
  },
  UGX: {
    currency: 'Ugandan Shilling',
    symbol: 'UGX',
    code: 'UGX',
    fraction: 2,
    country: 'UG',
  },
  UYU: {
    currency: 'Uruguayan Peso',
    symbol: '$U',
    code: 'UYU',
    fraction: 2,
    country: 'UY',
  },
  VEF: {
    currency: 'Venezuelan Bolivar',
    symbol: 'Bs',
    code: 'VEF',
    fraction: 2,
    country: 'VE',
  },
  VND: {
    currency: 'Vietnamese Dong',
    symbol: '₫',
    code: 'VND',
    fraction: 0,
    country: 'VN',
  },
  XAF: {
    currency: 'Central African Franc',
    symbol: 'F',
    code: 'XAF',
    fraction: 0,
    country: 'CM',
  },
  XOF: {
    currency: 'West African Franc',
    symbol: 'F',
    code: 'XOF',
    fraction: 2,
    country: 'SN',
  },
  XPF: {
    currency: 'Central Pacific Franc',
    symbol: 'F',
    code: 'XPF',
    fraction: 0,
    country: 'PF',
  },
  ZMW: {
    currency: 'Zambian Kwacha',
    symbol: 'ZK',
    code: 'ZMW',
    fraction: 2,
    country: 'ZM',
  },
}
